import React from 'react';

import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import Seo from '../../../../components/Misc/Seo';

import projectImage1 from '../../../../assets/images/work/nevada-gold-lock-tag/NevadaGoldLockTag_Slider_1.png';
import projectImage2 from '../../../../assets/images/work/nevada-gold-lock-tag/NevadaGoldLockTag_Slider_2.png';
import projectImage3 from '../../../../assets/images/work/nevada-gold-lock-tag/NevadaGoldLockTag_Slider_3.png';
import projectImage4 from '../../../../assets/images/work/nevada-gold-lock-tag/NevadaGoldLockTag_Slider_4.png';
import projectImage5 from '../../../../assets/images/work/nevada-gold-lock-tag/NevadaGoldLockTag_Slider_5.png';
import projectImage6 from '../../../../assets/images/work/nevada-gold-lock-tag/NevadaGoldLockTag_Slider_6.png';

import Data_NevadaGoldLockTag from './Data_NevadaGoldLockTag';

function Work_NevadaGoldLockTag() {
    const siteUrl = 'https://studio.norcat.org';
    const canonical = `${siteUrl}/OurWork/nevada-gold-lock-tag-program`;
    const title = 'Nevada Gold Lock and Tag Program | Immersive Safety Training';
    const description =
        'An immersive Lock and Tag program that lets Nevada Gold Corporation workers practise the complete energy isolation process safely.';
    const socialImage = `${siteUrl}${projectImage1}`;
    const sliderImages = [projectImage1, projectImage2, projectImage3, projectImage4, projectImage5, projectImage6].map(
        (image, index) => ({
            image,
            alt: `Nevada Gold Lock and Tag Program project preview ${index + 1}`,
        })
    );

    return (
        <>
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                ogImage={socialImage}
                ogImageAlt="Preview of the Nevada Gold Lock and Tag Program"
                twitterTitle={title}
                twitterDescription={description}
                twitterImage={socialImage}
                twitterImageAlt="Preview of the Nevada Gold Lock and Tag Program"
            />
            <DetailedHeader
                heading="Building Confidence in Lock and Tag Procedures"
                client="Nevada Gold Corporation"
                service="Experiential Training"
                date="2026"
            />
            <ImageSlider noArt="true" swiperNav="true" useButtonNav="true" images={sliderImages} />
            {Data_NevadaGoldLockTag.content}
        </>
    );
}

export default Work_NevadaGoldLockTag;
